
import React, { useState, useEffect } from 'react';
import smallLogo from '../images/logo.png'; // Update with your actual logo image path
import { Link } from 'react-router-dom';
//import io from 'socket.io-client';
import { io } from 'socket.io-client';
import moment from 'moment';
import {socketServerURL, socketServerURLNifty, apiURL, token, DB_CONFIG} from './GlobalParameters';
//import RightDiv from './RightDiv';
import DailyPlreport from './DailyPlreport';//, { totalPointsRef }
console.log("apiURL "+apiURL);
const socket = io(socketServerURL, {
    transports: ['websocket'], // Ensure WebSocket transport is used
   secure: true // Ensure secure connections if using HTTPS
});//'http://localhost:3030');
//const socketni = io(socketServerURLNifty);
if (!socket.connected) {
   socket.on('connect', () => {
     console.log('Connected to socket server');
   });
}
socket.on('connect_error', (err) => {
    console.error('Connection error:', err);
});
//localStorage.debug = 'socket.io-client:*';

socket.on('disconnect', () => {
  console.log('DisConnected to socket server');
});

/*if (!socketni.connected) {
  // socketni.on('connect', () => {
  //   console.log('Connected to Nifty socket server');
  // });
}

socketni.on('disconnect', () => {
  console.log('DisConnected to NI socket server');
});*/

let tempBNLiveTrades = [], tempNILiveTrades = [];

const TradingDashboard = () => {
//debugger;
console.log('API inside :'+apiURL);
let [fromDate, setFromDate] = useState(getTodayDate());
  let [toDate, setToDate] = useState(getTodayDate());
  let [reportTypes, setReportTypes] = useState({
    pnl: true,
    trend: false,
    fixedMargin: true,
    fixedLot: false
    //,cumulative: false,
  });  
  let [selectedBox, setSelectedBox] = useState("BANK NIFTY"); // State to track selected box => useState(null);
  let [ipData, setipData] = useState({fromDate: fromDate, toDate: toDate, reportTypes: reportTypes, selectedBox: selectedBox, Called: true});
  const [refreshKey, setRefreshKey] = useState(0); 
  const refreshComponent = () => { setRefreshKey(prevKey => prevKey + 1); setipData(ipData);};
    let [totalProfitLoss, setTotalProfitLoss] = useState(0);
    let [totalPoints, setTotalPoints] = useState(0), [totalTrades, setTotalTradeCount] = useState(0);
    let [positiveTrades, setPositiveTradeCount] = useState(0), [negativeTrades, setNegativeTradeCount] = useState(0);
    let [positiveGains, setPositiveGain] = useState(0), [negativeGains, setNegativeGain] = useState(0);
    let [error, setError] = useState(null); 
 
  const [marketData, setMarketData] = useState({
    Symbol: null,
    Price: null,
    firstIndex: null
    // midcap: null,
    // stocks: null,
    // equity: null,
  });
  const [NiftymarketData, setMarketDataNifty] = useState({
    Symbol: null,
    Price: null,
    firstIndex: null
    // midcap: null,
    // stocks: null,
    // equity: null,
  });
  const [FinNiftymarketData, setMarketDataFinNifty] = useState({
    Symbol: null,
    Price: null,
    firstIndex: null
    // midcap: null,
    // stocks: null,
    // equity: null,
  });
  const [MidcapmarketData, setMarketDataMidcap] = useState({
    Symbol: null,
    Price: null,
    firstIndex: null
    // midcap: null,
    // stocks: null,
    // equity: null,
  });
  const [BankmarketData, setMarketDataBank] = useState({
    Symbol: null,
    Price: null,
    firstIndex: null
    // midcap: null,
    // stocks: null,
    // equity: null,
  });
  const [EquitymarketData, setMarketDataEquity] = useState({
    Symbol: null,
    Price: null,
    firstIndex: null
    // midcap: null,
    // stocks: null,
    // equity: null,
  });
  let [liveTrades, setLiveTrades] = useState([]);
  //const [liveTrades, DisplayLiveTrades] = useState({ Symbol: null, Price: null, EntryTime: null, uuid: null, status: null });
  
  const [generateClicked, setGenerateClicked] = useState(false);

  useEffect(() => {
    const divs = document.querySelectorAll('.myDiv'); // Select all divs
    let currentIndex = 0; // To keep track of the div being hovered
    //console.log("totalPointsRef2 "+totalPointsRef.current);
    // Trigger hover every 60 seconds
    setInterval(simulateHover, 60000);

    function simulateHover() {
      // Remove 'hovered' class from all divs
      divs.forEach(div => div.classList.remove('hovered'));
  
      // Add 'hovered' class to the current div
      divs[currentIndex].classList.add('hovered');
  
      // Move to the next div
      currentIndex = (currentIndex + 1) % divs.length; // Loop back to the first div when we reach the end
    }
 
    socket.on('dataReceived', (data) => {//marketData
      if(data.Symbol === 'NIFTY BANK')
         setMarketData(data);
      //console.log('dataReceived' +JSON.stringify(data));
    });

    socket.on('new_Nifty', (data) => {//marketData
      //console.log('new_Nifty'+JSON.stringify(data));
      setMarketDataNifty(data);
      //marketData.Price = data.Price;
    });

    socket.on('new_FinNifty', (data) => {//marketData
      //console.log('new_FinNifty '+JSON.stringify(data));
      setMarketDataFinNifty(data);
    });

    socket.on('new_Midcap', (data) => {//marketData
      setMarketDataMidcap(data);
    });

    socket.on('new_Nifty1', (data) => {//marketData
        //console.log('new_Nifty1 '+JSON.stringify(data));
        if(data.Symbol === 'HDFCBANK')
        {
          setMarketDataBank(data);
        }
        else if(data.Symbol === 'ICICIBANK' || data.Symbol === 'AXISBANK' || data.Symbol === 'SBIN' || data.Symbol === 'KOTAKBANK' || data.Symbol === 'INDUSINDBK')
        {
          setMarketDataEquity(data);
        }
    });

    socket.on('traded_optionsV2', (trade) => {//live trade
      if (trade.status !== 'no trade') {
        //DisplayLiveTrades(trade);
        console.log("recent trade " + JSON.stringify(trade));
        //liveTrades.push(trade);
        if(ipData.selectedBox === 'BANK NIFTY')
        {
          setLiveTrades([trade]);//(prevTrades) => [trade, ...prevTrades]);  
        }
        tempBNLiveTrades = [trade];//TradeArr;
        if (trade.status === 'exit') {
          setTimeout(() => {
            //tempBNLiveTrades = [];//clear recent trade after 9 second
            //liveTrades = [];
          }, 9000);
        }
      }
    });

   /* socketni.on('traded_optionsV2', (trade) => {//live trade
      if (trade.status !== 'no trade') {
        console.log("recent NI trade " + JSON.stringify(trade));
        //liveTrades.push(trade);
        if (ipData.selectedBox === 'NIFTY') {
          setLiveTrades([trade]);//(prevTrades) => [trade, ...prevTrades]);
        }
        tempNILiveTrades = [trade];//TradeArr;
        if (trade.status === 'exit') {
          setTimeout(() => {
            //tempNILiveTrades = [];//clear recent trade after 9 second
            //liveTrades = [];
          }, 9000);
        }
      }
    });*/

    const fetchTradeData = async () => {
          try {//debugger;
            const today = new Date();
            const year = today.getFullYear();
            let month = today.getMonth() + 1;
            let day = today.getDate();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            let fromdtr = `${year}-${month}-${day}`;
            //const response = await fetch(apiURL + 'trendreport');
            let response = {}, data = {};
            if (selectedBox === "BANK NIFTY") {
              response = await fetch(apiURL + 'fixmargin?fromDt=' + fromdtr + '&toDt=' + fromdtr + '');
              data = await response.json();
            }
            else if (selectedBox === "NIFTY") {
                response = await fetch(apiURL + 'trendreportNifty50?fromDt=' + fromdtr + '&toDt=' + fromdtr + '&reportType=fixmargin');//response = await fetch(apiURL + 'trendreport');
              data = await response.json();
            }
            
            if (!response.ok) {
              console.log('Failed to fetch trendreport dashboard data');
              //throw new Error('Failed to fetch trendreport dashboard data');
            }
    
            let total = 0, arrData = (data && data.success) ? data.data[0] : null, arrLength = 0, originalBalance = 100000;
            let totalPoint = 0, positivetradecount = 0, negativetradecount = 0, positivegainpoints = 0, negativegainpoints = 0;
            if (Array.isArray(arrData)) {
              arrLength = arrData.length;
              arrData.forEach(function callback(item, index) {
                if (item && typeof item["PROFIT/LOSS"] === 'number') {
                  total += item["PROFIT/LOSS"];
                }
                if (item && typeof item["POINTS GAIN"] === 'number') {
                  totalPoint += item["POINTS GAIN"];
                }
                if (item && parseFloat(item["PROFIT/LOSS"]) >= 0) {
                  positivetradecount++;
                  positivegainpoints += parseFloat(item["PROFIT/LOSS"]);
                }
                if (item && parseFloat(item["PROFIT/LOSS"]) < 0) {
                  negativetradecount++;
                  negativegainpoints += Math.abs(parseFloat(item["PROFIT/LOSS"]));
                }
                if (item && typeof item["CumulativeBALANCE"] === 'number') {
                  if(index === 0)
                    item["CumulativeBALANCE"] = originalBalance + item["CumulativeBALANCE"];
                  else
                    item["CumulativeBALANCE"] = item["CumulativeBALANCE"] + arrData[index - 1]["CumulativeBALANCE"];
                }
                if (item && typeof item["row_num"] === 'number') {
                  item["row_num"] = index + 1;
                }
              });
            }    
            setTotalPoints(totalPoint);
            setTotalProfitLoss(total); 
            setPositiveTradeCount(positivetradecount);
            setNegativeTradeCount(negativetradecount); 
            setTotalTradeCount(arrLength);   
            setPositiveGain(positivegainpoints);
            setNegativeGain(negativegainpoints); 
            //setipData({fromDate: fromDate, toDate: toDate, reportTypes: reportTypes, selectedBox: selectedBox, Called: true});             
          } catch (err) {
            setError(err.message);
          }
        };
    
        // Call the fetch function
        fetchTradeData();    

    return () => {
      //socket.disconnect();
    };
  }, []);

  const getBoxColorClass = (value) => {
    if (value === null) return 'bg-gray-800'; // Dark background for loading state
    if(value === 'ongoing') return 'text-yellow-500'; 
    return value >= 0 ? 'text-green-500 bg-gray-900' : 'text-red-500 bg-gray-900'; // Adjust colors for positive and negative values
  };

  const getdivBoxColorClass = (value) => {
    if (value === null) return 'bg-gray-800'; // Dark background for loading state
    return value >= 0 ? 'text-green-500 bg-gray-800' : 'text-red-500 bg-gray-800'; // Adjust colors for positive and negative values
  };

  const formatNumber = (value) => {
    if (value === null) return 'Not available...';
    return value;//.toFixed(2);
  };

  const fnCallService = async () => {
    try {
      let response = {}, data = {};
      if (selectedBox === "BANK NIFTY") {
        if (ipData.fromDate && ipData.toDate && ipData.reportTypes && ipData.reportTypes.fixedMargin)
          response = await fetch(apiURL + 'fixmargin?fromDt=' + ipData.fromDate + '&toDt=' + ipData.toDate + '', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json'
   } });//response = await fetch(apiURL + 'trendreport');
        else if (ipData.fromDate && ipData.toDate && ipData.reportTypes && ipData.reportTypes.fixedLot)
          response = await fetch(apiURL + 'fixlot?fromDt=' + ipData.fromDate + '&toDt=' + ipData.toDate + '');
         data = await response.json();
      }
      else if (selectedBox === "NIFTY") {
        if (ipData.fromDate && ipData.toDate && ipData.reportTypes && ipData.reportTypes.fixedMargin)
          response = await fetch(apiURL + 'trendreportNifty50?fromDt=' + ipData.fromDate + '&toDt=' + ipData.toDate + '&reportType=fixmargin');//response = await fetch(apiURL + 'trendreport');
        else if (ipData.fromDate && ipData.toDate && ipData.reportTypes && ipData.reportTypes.fixedLot)
          response = await fetch(apiURL + 'trendreportNifty50?fromDt=' + ipData.fromDate + '&toDt=' + ipData.toDate + '&reportType=fixlot');
        data = await response.json();
      }
try {
console.log('JSON '+response);
//     data = await response.json();
if(!response.body.locked) {
const reader = response.body.getReader();

let receivedChunks = '';
const decoder = new TextDecoder('utf-8');

while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    receivedChunks += decoder.decode(value);
}

const jsonData = JSON.parse(receivedChunks);
console.log('Parsed JSON:', jsonData);  
//  console.log('Data:', data);
}
} catch (error) {
    console.error('Error parsing JSON:', error);
}
      if (!response.ok) {
        console.log('Failed to fetch service data');
        //throw new Error('Failed to fetch service data');
      }
      let total = 0, arrData = (data && data.success) ? data.data[0] : null, arrLength = 0, originalBalance = 100000;
      let totalPoint = 0, positivetradecount = 0, negativetradecount = 0, positivegainpoints = 0, negativegainpoints = 0;
      if (Array.isArray(arrData)) {
        arrLength = arrData.length;
        arrData.forEach(function callback(item, index) {
          if (item && typeof item["PROFIT/LOSS"] === 'number') {
            total += item["PROFIT/LOSS"];
          }
          if (item && typeof item["POINTS GAIN"] === 'number') {
            totalPoint += item["POINTS GAIN"];
          }
          if (item && parseFloat(item["PROFIT/LOSS"]) >= 0) {
            positivetradecount++;
            positivegainpoints += parseFloat(item["PROFIT/LOSS"]);
          }
          if (item && parseFloat(item["PROFIT/LOSS"]) < 0) {
            negativetradecount++;
            negativegainpoints += Math.abs(parseFloat(item["PROFIT/LOSS"]));
          }
          if (item && typeof item["CumulativeBALANCE"] === 'number') {
            if (index == 0)
              item["CumulativeBALANCE"] = originalBalance + item["CumulativeBALANCE"];
            else
              item["CumulativeBALANCE"] = item["CumulativeBALANCE"] + arrData[index - 1]["CumulativeBALANCE"];
          }
          if (item && typeof item["row_num"] === 'number') {
            item["row_num"] = index + 1;
          }
        });
      }
      setTotalPoints(totalPoint);
      setTotalProfitLoss(total);
      setPositiveTradeCount(positivetradecount);
      setNegativeTradeCount(negativetradecount);
      setTotalTradeCount(arrLength);
      setPositiveGain(positivegainpoints);
      setNegativeGain(negativegainpoints);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGenerateReport = async () => {
    ipData.Called = true;
    console.log(`Generating report from ${fromDate} to ${toDate} with types:`, reportTypes);
    if(new Date(fromDate) > new Date(toDate))
      alert("Please select valid FromDate/ToDate.");
    refreshComponent();
    await fnCallService();
    //setipData(ipData);
    //setGenerateClicked(true);
    // try {
    //   const responses = await fetch(apiURL + 'trendreport');
    //   if (!responses.ok) {
    //     throw new Error('Failed to fetch trendreport data');
    //   }
    //   const datas = await responses.json();
    // }
    // catch (error) {
    //   console.error('Error fetching data from trendreport:', error);
    // }
  };

  const handleReportTypeChange = (type) => {
    ipData.Called = false;
    // setReportTypes((prevTypes) => ({
    //   ...prevTypes,
    //   [type]: !prevTypes[type],
    // }));
    let newTypes = {pnl: true,
      trend: false,
      fixedMargin: true,
      fixedLot: false};
    setReportTypes((prevTypes) => { // Create a new state object 
      newTypes = { ...prevTypes, [type]: !prevTypes[type], };
      // If fixedMargin is set to true, set fixedLot to false 
      if (type === 'fixedMargin' && newTypes[type] === true) { newTypes.fixedLot = false; }
      // If fixedLot is set to true, set fixedMargin to false
      if (type === 'fixedLot' && newTypes[type] === true) { newTypes.fixedMargin = false; }
      if (type === 'pnl' && newTypes[type] === true) { newTypes.trend = false; }
      if (type === 'trend' && newTypes[type] === true) { newTypes.pnl = false; }
     // return newTypes;
    //});
    if (type === 'fixedMargin') { ipData.reportTypes.fixedLot = false; ipData.reportTypes.fixedMargin = true; }
    // If fixedLot is set to true, set fixedMargin to false
    if (type === 'fixedLot') { ipData.reportTypes.fixedMargin = false; ipData.reportTypes.fixedLot = true; }
    if (type === 'pnl') { ipData.reportTypes.trend = false; ipData.reportTypes.pnl = true; }
    if (type === 'trend') { ipData.reportTypes.pnl = false; ipData.reportTypes.trend = true; }
    //ipData.reportTypes = newTypes;
    setipData(ipData);

     return newTypes;
     });
  };

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
    if (month < 10) month = `0${month}`;
    if (day < 10) day = `0${day}`;
    return `${year}-${month}-${day}`;
  }

  const handleFromDateChange = (e) => { console.log("Selected from date:", e.target.value); // Log the selected date 
  setFromDate(e.target.value); ipData.fromDate = e.target.value; ipData.Called = false;};

  const handleToDateChange = (e) => { console.log("Selected to date:", e.target.value); // Log the selected date 
    setToDate(e.target.value); ipData.toDate = e.target.value; ipData.Called = false;};

  const boxes = [
    { name: 'BANK NIFTY', value: marketData.Price, diff: marketData.firstIndex, size: 'text-4xl' },
    { name: 'NIFTY', value: NiftymarketData.Price, diff: NiftymarketData.firstIndex, size: 'text-4xl' },
    { name: 'FIN NIFTY', value: FinNiftymarketData.Price, diff: FinNiftymarketData.firstIndex, size: 'text-3xl' },
    { name: 'MIDCAP', value: MidcapmarketData.Price, diff: MidcapmarketData.firstIndex, size: 'text-3xl' },
    { name: 'STOCKS', value: BankmarketData.Price, diff: BankmarketData.Symbol, size: 'text-3xl' },
    { name: 'EQUITY', value: EquitymarketData.Price, diff: EquitymarketData.Symbol, size: 'text-3xl' },
  ];

  const selectBox = (boxName) => {
    setSelectedBox(boxName);
    ipData.selectedBox = boxName;
    if(boxName === 'BANK NIFTY')// && tempBNLiveTrades.length > 0
      setLiveTrades(tempBNLiveTrades);
    else if(boxName === 'NIFTY')// && tempNILiveTrades.length > 0
      setLiveTrades(tempNILiveTrades); 
  };

  const renderSelectedBoxContent = () => {
    if (selectedBox) {
      return (
        <div className="flex items-center justify-center my-1 mt-1 w-full text-between">
          <span className="text-gray-200 text-lg font-bold perucol">{selectedBox}</span>
        </div>
      );
    } else {
      return null; // Return null if no box is selected
    }
  };
  
  return (
    <div className="h-screen flex flex-col bg-gray-800">
      {/* Navbar */}
      <nav className="bg-gray-400 p-4 flex items-center justify-between" id="dvHeadSpace">
        {/* Left Section - Logo */}
        <div className="flex items-center">
          <img src={smallLogo} id="imgDLogo" className="w-40 h-auto mr-2" alt="Logo" />
        </div>

        {/* Center Section - Title */}
        <h1 id="h1NoHeight" className="text-2xl md:text-3xl lg:text-4xl font-bold text-white flex-grow text-center transition duration-300 ease-in-out transform hover:scale-105">
          {/* <span className="inline-block">USPL</span> */}
          <span className="inline-block" id="spreport">Paper Trade Report</span>
        </h1>

        {/* Right Section - Back Button */}
        <Link id="lnkBackBtn"
          to="/"
          className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-lg transition duration-300 ease-in-out hidden lg:block"
        >
          Back
        </Link>
      </nav>

      {/* Main Content */}
      <div className="flex flex-grow">
        {/* Left Section (40% width) */}
        <div id="dvLeftSide" className="flex flex-col w-2/5 bg-gray-900 p-4">
          {/* Six Boxes */}
          <h2 id="h2livestatus" className="text-lg font-semibold mb-4 text-center text-white">Live Market Status</h2>
          <div className="grid grid-cols-2 gap-4">
            {boxes.map((box, index) => (
              <div tabIndex={index}
                key={index}
                className={`dvIndicesBox myDiv border border-gray-800 rounded-lg p-4 mb-4 shadow-md transition duration-200 ease-in-out transform hover:scale-105 cursor-pointer ${getdivBoxColorClass(
                  box.value
                )} ${selectedBox === box.name ? 'ring-2 ring-blue-500' : ''}`}
                onClick={() => selectBox(box.name)}
              >
                <h3 className={`h3Boxname text-lg font-semibold mb-2 ${box.size} text-white`}>{box.name}</h3>
                <div className={`dvMqIndices text-gray-200 text-3xl font-bold ${getBoxColorClass(box.value - box.diff)}`}>
                  <marquee>{formatNumber(Math.floor(box.value))}({ ( (isNaN(box.diff)) || (box.value - box.diff < 0) )  ? '' : '+'}{ isNaN(box.diff) ? box.diff : (box.value - box.diff).toFixed(0) } )</marquee>
                </div>
              </div>
            ))}
          </div>

          {/* Live Trades Container (Below Six Boxes) */}
          <div className="mt-8" id="dvLiveTrades">
            <h2 id="h2LiveTrades" className="text-lg font-semibold mb-4 text-center text-white">Live Trades</h2>
            <div id="MinHeight" className="overflow-y-auto h-48 border border-gray-800 rounded-lg p-4 shadow-md transition duration-200 ease-in-out transform hover:scale-105 bg-gray-700">
              {/* Live Trades List */}
              {liveTrades.length > 0 ? (
                liveTrades.map((trade, index) => (
                  <div
                    key={trade.uuid}
                    className={`mb-4 p-4 bg-gray-800 rounded-lg transition duration-200 ease-in-out transform hover:scale-105 ${
                      index === 0 ? 'animate-bounce' : ''
                    }`}
                  >
                    <p className={`text-gray-200 ${ trade.status === 'buy' ? (getBoxColorClass(1)) : ( (trade.status === 'ongoing') ? (getBoxColorClass('ongoing')) : (getBoxColorClass(-1)) ) }`}>Symbol: {trade.Symbol}</p>
                    <p className={`text-gray-200 ${ trade.status === 'buy' ? (getBoxColorClass(1)) : ( (trade.status === 'ongoing') ? (getBoxColorClass('ongoing')) : (getBoxColorClass(-1)) ) }`}>Entry Time: {new Date(trade.EntryTime).toLocaleTimeString()}</p>
                    <div className='txt-bck_cg'> <span className={`text-gray-200 txt-bck_cg ${ trade.status === 'buy' ? (getBoxColorClass(1)) : ( (trade.status === 'ongoing') ? (getBoxColorClass('ongoing')) : (getBoxColorClass(-1)) ) }`}>Entry Price: {trade.EntryPrice}</span>
                    <span className={`text-gray-200 flright ${ trade.status === 'buy' ? (getBoxColorClass(1)) : ( (trade.status === 'ongoing') ? (getBoxColorClass('ongoing')) : (getBoxColorClass(-1)) ) }`}>LTP: {trade.Price}</span></div> 
                    <p className={`text-gray-200 ${ trade.status === 'buy' ? (getBoxColorClass(1)) : ( (trade.status === 'ongoing') ? (getBoxColorClass('ongoing')) : (getBoxColorClass(-1)) ) }`}>Points gain: {(trade.Price - trade.EntryPrice).toFixed(2)}</p>
                  </div>
                ))
              ) : (
                <p className="text-gray-200 text-center">No live trades available.</p>
              )}
            </div>
          </div>
        </div>

        {/* Right Section (60% width) */}
        <div id="dvRightSide" className="w-3/5 bg-gray-800 p-4">
          {/* Container for Date Selection and Report Type */}
          <div className="flex items-center mbs10">
            <div className="flex flex-row flex-1 mr-4">
              <label className="block wid20 mt10 text-sm font-medium text-white">From Date :</label>
              <input title='From date' id="inpFromDate"
                type="date"
                value={fromDate}
                onChange={handleFromDateChange /*(e) => setFromDate(e.target.value)*/}
                className="mt-1 block wid80 w-full px-3 py-2 border border-gray-700 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md transition duration-200 ease-in-out hover:bg-gray-700"
              />
            </div>
            <div className="flex flex-row flex-1 mr-4">
              <label className="block wid20 mt10 text-sm font-medium text-white">To Date :</label>
              <input title='To date' id="inToDate"
                type="date"
                value={toDate}
                onChange={handleToDateChange /*(e) => setToDate(e.target.value)*/}
                className="mt-1 block wid80 w-full px-3 py-2 border border-gray-700 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md transition duration-200 ease-in-out hover:bg-gray-700"
              />
            </div>
            <button
              className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg transition duration-200 ease-in-out transform hover:scale-105 ${
                generateClicked ? 'bg-green-500 hover:bg-green-700' : ''
              }`}
              onClick={handleGenerateReport}
            >
              Generate
            </button>
          </div>

       {/* Report Type Selection */}
          <div className="flex items-center mbs10">
          <div className="flex-1">
          <label className="block text-sm font-medium text-white"></label>
          <div className="flex flex-wrap mt-1">
      {/* P&L Report Type */}
          <div className="mr-4">
          <div className="flex items-center">
          <input
            type="radio"
            id="pnl"
            checked={reportTypes.pnl}
            onChange={() => handleReportTypeChange('pnl')}
            className="mr-2 transition duration-200 ease-in-out transform hover:scale-105"
          />
          <label htmlFor="pnl" className="text-gray-200 cursor-pointer transition duration-200 ease-in-out hover:text-blue-600">P&L</label>
          </div>
          </div>
      {/* Trend Report Type */}
         <div className="mr-4">
        <div className="flex items-center">
          <input
            type="radio"
            id="trend"
            checked={reportTypes.trend}
            onChange={() => handleReportTypeChange('trend')}
            className="mr-2 transition duration-200 ease-in-out transform hover:scale-105"
          />
          <label htmlFor="trend" className="text-gray-200 cursor-pointer transition duration-200 ease-in-out hover:text-blue-600">Trend</label>
        </div>
         </div>
      {/* Selected box content in the center */}
         <div className="col-span-1 flex justify-center items-center text-center flex-grow">
        <div className="text-20xl font-bold transition duration-200 ease-in-out transform hover:scale-105">
          {renderSelectedBoxContent()}
        </div>
         </div>
      {/* Fixed Margin Report Type */}
         <div className="mr-4 ml-auto">
        <div className="flex items-center">
          <input
            type="radio"
            id="fixedMargin"
            checked={reportTypes.fixedMargin}
            onChange={() => handleReportTypeChange('fixedMargin')}
            className="mr-2 transition duration-200 ease-in-out transform hover:scale-105"
          />
          <label htmlFor="fixedMargin" className="text-gray-200 cursor-pointer transition duration-200 ease-in-out hover:text-blue-600">Fixed Margin</label>
        </div>
         </div>
      {/* Fixed Lot Report Type */}
        <div className="mr-4">
        <div className="flex items-center">
          <input
            type="radio"
            id="fixedLot"
            checked={reportTypes.fixedLot}
            onChange={() => handleReportTypeChange('fixedLot')}
            className="mr-2 transition duration-200 ease-in-out transform hover:scale-105"
          />
          <label htmlFor="fixedLot" className="text-gray-200 cursor-pointer transition duration-200 ease-in-out hover:text-blue-600">Fixed Lot</label>
        </div>
        </div>
      {/* Cumulative Report Type */}
         {/* <div className="mr-4">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="cumulative"
            checked={reportTypes.cumulative}
            onChange={() => handleReportTypeChange('cumulative')}
            className="mr-2 transition duration-200 ease-in-out transform hover:scale-105"
          />
          <label htmlFor="cumulative" className="text-gray-200 cursor-pointer transition duration-200 ease-in-out hover:text-blue-600">Cumulative</label>
        </div>
         </div> */}
          </div>
          </div>
          </div>
       {/*<RightDiv />*/}
          {/* Trades Display Container */}
          <div id="dvRecordTable" className="mt10 nopadding rounded-lg bg-gray-900 shadow-md p-8 md:p-12 lg:p-16 transition duration-200 ease-in-out transform hover:scale-102">
            {/* <h2 className="text-lg font-semibold mb-4 text-center text-white">Display the trades</h2> */}
            <div id="dvMinHeight" className="border border-gray-800 rounded-lg p-2 md:p-2 lg:p-2 shadow-md transition duration-200 ease-in-out transform hover:scale-102 bg-gray-700">
              {/* <p className="text-gray-200 text-center">No records available.</p> */}
              {<DailyPlreport key={refreshKey} ipData={ipData} />}
            </div>
          </div>

          {/* Total P&L and Points Gain */}
          <div className="mt10 rounded-lg bg-gray-900 shadow-md p-2 transition duration-200 ease-in-out transform hover:scale-102">
            <h2 className="text-lg font-semibold text-center text-white"></h2>
            <div className="flex justify-between">
              <div className="flex flex-row">
                <span className="text-sm mt5 font-medium text-gray-200">Total P&L :</span>
                <span className={`text-lg font-semibold text-gray-100 ml-2 ${getBoxColorClass(totalProfitLoss)}`}>{totalProfitLoss.toFixed(2)}</span>
              </div>
              <div className="flex flex-row">
                <span className="text-sm mt5 font-medium text-gray-200">Points Gain :</span>
                <span className={`text-lg font-semibold text-gray-100 ml-2 ${getBoxColorClass(totalPoints)}`}>{totalPoints.toFixed(2)}</span>
              </div>
            </div>
          </div>

          {/* Statistics */}
          <div className="mt10 rounded-lg bg-gray-900 shadow-md p-4 transition duration-200 ease-in-out transform hover:scale-102">
            <h2 className="text-lg font-semibold text-center text-white"></h2>
            <div className="flex justify-between">
              <div className="flex flex-row">
                <span className="text-sm mt5 font-medium text-gray-200">No of Trades :</span>
                <span className={`text-lg font-semibold text-gray-100 ml-2`}>{totalTrades}</span>
              </div>
              <div className="flex flex-row">
                <span className="text-sm mt5 font-medium text-gray-200">+ Trades :</span>
                <span className={`text-lg font-semibold text-gray-100 ml-2 ${getBoxColorClass(1)}`}>{positiveTrades}</span>
              </div>
              <div className="flex flex-row">
                <span className="text-sm mt5 font-medium text-gray-200">- Trades :</span>
                <span className={`text-lg font-semibold text-gray-100 ml-2 ${getBoxColorClass(-1)}`}>{negativeTrades}</span>
              </div>
              <div className="flex flex-row">
                <span className="text-sm mt5 font-medium text-gray-200">Points Gain Rate % :</span>
                <span className={`text-lg font-semibold text-gray-100 ml-2 ${getBoxColorClass((positiveGains - negativeGains) * 100/(positiveGains + negativeGains))}`}>{ ((positiveGains - negativeGains) * 100/(positiveGains + negativeGains)) ? ((positiveGains - negativeGains) * 100/(positiveGains + negativeGains)).toFixed(2) : 0 }</span>
              </div>
              <div className="flex flex-row">
                <span className="text-sm mt5 font-medium text-gray-200">Trade Win Rate % :</span>
                <span className={`text-lg font-semibold text-gray-100 ml-2 ${getBoxColorClass((positiveTrades / totalTrades) * 100)}`}>{!isNaN((positiveTrades / totalTrades) * 100) ? ((positiveTrades / totalTrades) * 100).toFixed(2) : 0}</span>
              </div>
              <div className="flex flex-row">
                <span className="text-sm mt5 font-medium text-gray-200">ROI % :</span>
                <span className={`text-lg font-semibold text-gray-100 ml-2 ${getBoxColorClass((totalProfitLoss*100/100000))}`}>{(totalProfitLoss*100/100000).toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingDashboard;
